const isProd = process.env.NODE_ENV === 'production';
const debugID = '108845574'; // FOR DEV: Add employeeID here for local testing

export const METADATA_DEFAULT = {
    employeeId: isProd ? '' : debugID,
    workLocation: 'VIR',
};
